<ng-template #content let-c="close" id="modal">
  <div class="modal-header">
    <h4 class="modal-title">Update email</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="onDismiss()">
    </button>
  </div>
  <div class="modal-body">
      <form [formGroup]="accountForm" (ngSubmit)="onSubmit();">
        <div class="row modal-new">
          <div class="col-md-12">
            <div class="form-group">
              <span class="modal-form-text">New email</span>
              <input type="text"
                     class="form-control"
                     formControlName="email"
                     #emailInput
                     required>
              <span class="text-danger" *ngIf="accountForm.get('email').touched && accountForm.get('email').errors?.required">
                Email is required
              </span>
              <span class="text-danger" *ngIf="accountForm.get('email').errors?.email">
                Enter a valid email address
              </span>
            </div>
          </div>
        </div>
      </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-cancel" (click)="onDismiss()">Cancel</button>
    <button type="submit" [disabled]="!accountForm.valid  || isLoading"
            class="btn-primary btn-save" (click)="onSubmit()">Save</button>
  </div>
</ng-template>
